export default __webpack_public_path__ + "static/media/_DSC0810.d38684c7.JPG";